module.exports = __webpack_public_path__ + "img/antes_despues_313.41e8b727.png";